import { Component, Mixins, Prop, Watch } from 'vue-property-decorator'
import api from '@webparts/api'
import { LoadingBar } from '@appbase/components/loading'
import NoData from '@webparts/components/common/NoData.vue'
import WebpartBase from '@webparts/components/webparts/base/WebpartBase'
import WebpartTemplate from '@webparts/components/webparts/base/WebpartTemplate.vue'
import TabHead from '@webparts/components/webparts/YASKAWA/Board/TabHead.vue'
import menuHelper from '@appbase/util/menu-helper'

import ImageList from '@webparts/components/webparts/YASKAWA/Board/ImageList.vue'
import SummaryList from '@webparts/components/webparts/YASKAWA/Board/SummaryList.vue'

const tempData = [
    {
        createdDate: new Date(),
        prefaceText: '인사',
        title: '운영그룹 내 팀 이동 안내',
        content: `인사총무팀에서 운영그룹 내 팀 이동 건 안내드립니다.`,
    },
    {
        createdDate: '2022-10-28',
        prefaceText: '공지',
        title: '2022년도 직장인 건강검진 공지사항',
        content: `인사총무팀에서 건강검진 공지 드립니다.1) Vision-ReminVision-ReminVision-Remin`,
    },
    {
        createdDate: '2022-10-28',
        prefaceText: '공지',
        title: '2022년 11월 조직도 안내',
        content: `업무에 참고 바랍니다.1) Vision-Remin`,
    },
    {
        createdDate: '2022-10-28',
        prefaceText: '공지',
        title: '2022년 11월 조직도 안내',
        content: `업무에 참고 바랍니다.1) Vision-Remin`,
    },
    {
        createdDate: '2022-10-28',
        prefaceText: '공지',
        title: '2022년 11월 조직도 안내',
        content: `업무에 참고 바랍니다.1) Vision-Remin`,
    },
    {
        createdDate: '2022-10-28',
        prefaceText: '공지',
        title: '2022년 11월 조직도 안내',
        content: `업무에 참고 바랍니다.1) Vision-Remin`,
    },
    {
        createdDate: '2022-10-28',
        prefaceText: '공지',
        title: '2022년 11월 조직도 안내',
        content: `업무에 참고 바랍니다.1) Vision-Remin`,
    },
    {
        createdDate: '2022-10-28',
        prefaceText: '공지',
        title: '2022년 11월 조직도 안내',
        content: `업무에 참고 바랍니다.1) Vision-Remin`,
    },
    {
        createdDate: '2022-10-28',
        prefaceText: '공지',
        title: '2022년 11월 조직도 안내',
        content: `업무에 참고 바랍니다.1) Vision-Remin`,
    },
];

@Component({
    name: 'noticeboard-webpart',
    components: {
        LoadingBar,
        NoData,
        WebpartTemplate,
        TabHead,
        ImageList,
        SummaryList
    }    
})
export default class BoardNoticeWebpart extends Mixins(WebpartBase) {
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //
    @Prop({ type: Object }) webpart!: webpartv3.Webpart;

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //
    popupBaseUrl!: string;

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //
    articles: webpartBoard.WebpartArticle[] = [];
    boardId: number = 0;
    page: number = 1;
    itemsPerPage: number = 5;
    options: any = null;
    imagePath: string = '';
    includeContent: boolean = false;
    showImage: boolean = false;   
   

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //
    // 웹파트 옵션 저장값 set
    setProps() {
        this.options =
            typeof this.webpart.props == typeof '' ? JSON.parse(this.webpart.props as string) : this.webpart.props;
        this.boardId = this.options.prop[0].boardId;
        this.itemsPerPage = this.options.prop[0].displayCount;
        this.includeContent = this.options.prop[0].includeContent;
        this.showImage = this.options.prop[0].showImage;
    }
    
    async load() {
        this.loading = true;
        await api.board
            .getWebpartArticles({
                targetBoards: [this.boardId],
                itemsPerPage: this.itemsPerPage,
                page: this.page,
                includeContent: this.includeContent,
            })
            .then(res => {
                this.articles = res.data;
            });

        this.loading = false;
    }

    tabChange(val: any) {
        this.showImage = val.showImage;
        this.boardId = val.boardId;
        this.itemsPerPage = val.displayCount;
        this.page = 1;
        this.load();
    }      

    moveTo() {
        if (this.preview) return;
        let menu = menuHelper.findOneBySysId(this.boardId, 'BB');
        if (!menu) menu = menuHelper.findOneBySysId(this.boardId, 'GF');
        if (menu) {
            menuHelper.next(menu);
        }
    }
   
    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: W A T C H E S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //
    @Watch('webpart.props')
    changeWebpartValue() {
        this.setProps();
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E S T Y L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //
    created() {
        if (this.webpart && this.webpart.props) {
            this.setProps();
        }

        if (this.preview) {
            this.articles = tempData as any;
        } else this.load();
    }
}
